var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('v-col',{staticClass:"mt-12"},[_c('v-btn',{on:{"click":function($event){return _vm.getAllMoocs()}}},[_vm._v("asdadasdqwd")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }